module.exports = __webpack_public_path__ + "img/404.9d6e39b0.png";